export default __webpack_public_path__ + "static/media/imageForFilter3_648x448.640a1d82.jpg";